import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Modal,
  Grid,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
export default function DisplayOutStandingReport({ open, setOpen, modalData }) {
  const [pagination, setPagination] = useState({ page: 1, total: 10 });

  const data = {
    customerMobile: "",
  };
  const onClose = () => {
    setOpen(false);
  };
  const handleChange = (event, value) => {
    setPagination({
      ...pagination,
      page: value,
    });
  };

  useEffect(() => {
    if (open === true) {
    } else {
      console.log("close");
    }
  }, [open]);

  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          overflowY: "auto",
          width: { xs: "95%", sm: "85%", md: "50%", lg: "40%", xl: "40%" },

          borderRadius: "10px",
          // height: "80vh",
          position: "absolute",
          left: { xs: "2%", sm: "5%", md: "25%", lg: "25%", xl: "30%" },

          top: "10%",
        }}
      >
        <DialogTitle
          color="primary"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: "600",
            padding: "10px 15px",
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
          }}
        >
          Outstanding Bill{" "}
          <IconButton
            onClick={() => setOpen(false)}
            sx={{ color: "#000000", p: 0 }} // optional: remove padding
          >
            <CloseIcon
              sx={{ fontSize: { xs: "12px", sm: "13px", md: "30px" } }}
            />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderBottom: "1px solid #01008B" }} />

        <Grid container sx={{ p: "10px" }}>
          {/* <Grid item xs={12} sx={{ p: "0px 10px " }}>
            <Box
              sx={{
                border: "1px solid grey",
                // padding: "16.5px 14px",
                borderRadius: "4px",
                display: "flex",

                marginTop: "4px",
                height: "40px",
                alignItems: "center",
              }}
            >
              <Typography sx={{ margin: "0px 10px" }}>Table No: </Typography>
              <Typography
                sx={{
                  fontWeight: "600",
                  color: (theme) => theme.palette.secondary.main,
                }}
              >
                table{" "}
              </Typography>
            </Box>
          </Grid> */}
          {/* <Grid item xs={4} sx={{ p: "0px 10px " }}>
            <Box
              sx={{
                border: "1px solid grey",

                mt: 2,
                // padding: "16.5px 14px",
                height: "40px",
                borderRadius: "4px",
                display: "flex",

                // marginTop: "4px",
                alignItems: "center",
              }}
            >
              <Typography sx={{ margin: "0px 10px" }}>Bill No: </Typography>
              <Typography>{modalData?.billNumber}</Typography>
            </Box>
          </Grid>
          <Grid item xs={8} sx={{ p: "0px 10px " }}>
            <Box
              sx={{
                mt: 2,
                border: "1px solid grey",
                // padding: "16.5px 14px",
                height: "40px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography sx={{ margin: "0px 10px" }}>Bill Date: </Typography>
              <Typography>{modalData?.billDate?.split("T")[0]}</Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sx={{ p: "0px 10px " }}>
            <TextField
              fullWidth
              label="Mobile Number"
              value={modalData?.buyerMobile}
              sx={{
                mt: 2,
              }}
              InputProps={{
                style: {
                  height: "40px",
                  // background:"yellow"
                },
              }}
              onChange={(e) => {
                // getUnpaid({
                //   customerMobile: e.target.value,
                // });
                // setSearch(e.target.value);
              }}
            />
          </Grid>

          <Grid item xs={6} sx={{ p: "0px 10px " }}>
            <TextField
              fullWidth
              label="Customer Name"
              value={modalData?.buyerName}
              sx={{
                mt: 2,
              }}
              InputProps={{
                style: {
                  height: "40px",
                  // background:"yellow"
                },
              }}
              onChange={(e) => {
                // getUnpaid({
                //   customerMobile: e.target.value,
                // });
                // setSearch(e.target.value);
              }}
            />
          </Grid> */}

          <Grid container spacing={2} sx={{ px: 1, py: 1 }}>
            <Grid item xs={12} md={7}>
              <Box
                display="flex"
                justifyContent="space-between"
                mb={0.5}
                flexWrap="wrap"
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: "#01008B",
                    minWidth: "120px",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Appointment Id:
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: "#000000",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {modalData?.appointmentId}
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                mb={0.5}
                flexWrap="wrap"
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: "#01008B",
                    minWidth: "120px",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Customer Name:
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: "#000000",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {modalData?.buyerName}
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                mb={0.5}
                flexWrap="wrap"
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: "#01008B",
                    minWidth: "120px",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Mobile Number:
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: "#000000",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {modalData?.buyerMobile}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={5}>
              <Box
                display="flex"
                justifyContent="space-between"
                mb={0.5}
                flexWrap="wrap"
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: "#01008B",
                    minWidth: "80px",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Bill No.:
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: "#000000",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {modalData?.billNumber}
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                flexWrap="wrap"
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: "#01008B",
                    minWidth: "80px",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Bill Date:
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: "#000000",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {convertDateToCustomFormat(
                    modalData?.billDate?.split("T")[0]
                  )}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider
              sx={{
                borderStyle: "dotted",
                borderColor: "#6C6C6C",
                borderWidth: "0 0 1px 0",
                my: 1,
                width: "100%",
              }}
            />
          </Grid>

          {/* {modalData?.counterSalesChild.map((item2, index) => {
            return (
              <Grid item xs={12} sm={12} sx={{ p: "5px 10px" }}>
                <Typography
                  sx={{
                    fontWeight: "600",
                    padding: "0px !important",
                    margin: "0px important",
                    color: (theme) => theme.palette.secondary.main,
                  }}
                >
                  {item2.itemDescription}
                </Typography>
                <Grid container>
                  <Grid
                    item
                    xs={2}
                    sx={{
                      padding: "0px !important",
                      margin: "0px important",
                    }}
                  >
                    <Typography
                      sx={{
                        padding: "0px !important",
                        margin: "0px important",
                        color: (theme) => theme.palette.primary.main,
                      }}
                    >
                      {item2?.quantity}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={8}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <CurrencyRupeeIcon
                      color="primary"
                      sx={{ fontSize: "14px" }}
                    />

                    <Typography
                      sx={{
                        padding: "0px !important",
                        margin: "0px important",
                        color: (theme) => theme.palette.primary.main,
                      }}
                    >
                      {item2?.rate?.toFixed(2)}/Nos
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sx={{
                      color: (theme) => theme.palette.secondary.main,
                      display: "flex",

                      alignItems: "center",
                    }}
                  >
                    <CurrencyRupeeIcon
                      color="secondary"
                      sx={{ fontSize: "14px" }}
                    />

                    <Typography
                      sx={{
                        padding: "0px !important",
                        margin: "0px important",
                      }}
                    >
                      {item2?.amount?.toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>

                <Divider
                  sx={{
                    backgroundColor: "black",
                    // backgroundColor: (theme) => theme.palette.primary.main,
                    mt: "2px",
                  }}
                />
              </Grid>
            );
          })} */}
          <Box
            // onClick={(e) => e.stopPropagation()}
            sx={{
              width: "100%",
              maxHeight: "30vh",
              overflowY: "auto",
              pr: 1,
            }}
          >
            {modalData?.counterSalesChild.map((item2, index) => (
              <Grid key={index} item xs={12} sx={{ px: 2, py: 1 }}>
                <Grid container alignItems="center">
                  <Grid item xs={12} md={4}>
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#01008B",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      {item2.itemDescription}
                    </Typography>
                  </Grid>
                  <Grid container xs={12} md={12}>
                    <Grid item xs={6} md={6}>
                      <Typography
                        sx={{
                          textAlign: {xs:"left", md:"right"},
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: "500",
                        }}
                      >
                        Qty: {item2.quantity}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <Typography
                        sx={{
                          textAlign: {md:"right", xs:"right"},
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: "500",
                        }}
                      >
                        ₹ {item2.rate?.toFixed(2)}/{item2.unit}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={12}>
                  <Grid item xs={6} md={6}>
                    <Typography
                      sx={{
                        textAlign: "left",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: "500",
                      }}
                    >
                      {item2.employeeName} ({item2.employeePayPercentage}%)
                    </Typography>
                  </Grid>

                  <Grid item xs={6} md={6}>
                    <Typography
                      sx={{
                        textAlign: "right",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: "500",
                        mt:2
                      }}
                    >
                      Total: ₹ {item2.amount?.toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>

                <Divider
                  sx={{
                    borderColor: "#666666",
                    my: 1,
                  }}
                />
              </Grid>
            ))}
          </Box>
          <Grid item xs={12}>
            <Divider
              sx={{
                borderStyle: "dotted",
                borderColor: "#6C6C6C",
                borderWidth: "0 0 1px 0",
                my: 1,
                width: "100%",
              }}
            />
          </Grid>

          {/* <Grid item xs={12} sx={{ p: "10px" }}>
            <Divider
              sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
            />
          </Grid> */}

          <Grid item xs={6} sx={{ p: "0px 10px " }}>
            <Typography
              sx={{
                fontWeight: "500",
                color: "#000000",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // color: (theme) => theme.palette.primary.main,
              }}
            >
              Bill Amount:
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ p: "0px 10px ", textAlign: "right" }}>
            <Typography
              sx={{
                fontWeight: "600",
                color: "#000000",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // color: (theme) => theme.palette.secondary.main,
              }}
            >
              {modalData?.billAmount?.toFixed(2)}
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ p: "0px 10px " }}>
            <Typography
              sx={{
                fontWeight: "500",
                color: "#000000",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // color: (theme) => theme.palette.primary.main,
              }}
            >
              CGST(%):
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ p: "0px 10px ", textAlign: "right" }}>
            <Typography
              sx={{
                fontWeight: "600",
                color: "#000000",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // color: (theme) => theme.palette.secondary.main,
              }}
            >
              {modalData?.counterSalesChild?.[0]?.cgst.toFixed(2)}
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ p: "0px 10px " }}>
            <Typography
              sx={{
                fontWeight: "500",
                color: "#000000",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // color: (theme) => theme.palette.primary.main,
              }}
            >
              SGST(%):
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ p: "0px 10px ", textAlign: "right" }}>
            <Typography
              sx={{
                fontWeight: "600",
                color: "#000000",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // color: (theme) => theme.palette.secondary.main,
              }}
            >
              {modalData?.counterSalesChild?.[0]?.sgst.toFixed(2)}
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ p: "0px 10px " }}>
            <Typography
              sx={{
                fontWeight: "500",
                color: "#000000",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // color: (theme) => theme.palette.primary.main,
              }}
            >
              IGST(%):
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ p: "0px 10px ", textAlign: "right" }}>
            <Typography
              sx={{
                fontWeight: "600",
                color: "#000000",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // color: (theme) => theme.palette.secondary.main,
              }}
            >
              {modalData?.counterSalesChild?.[0]?.igst.toFixed(2)}
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ p: "0px 10px " }}>
            <Typography
              sx={{
                fontWeight: "500",
                color: "#000000",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // color: (theme) => theme.palette.primary.main,
              }}
            >
              Discount:
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ p: "0px 10px ", textAlign: "right" }}>
            <Typography
              sx={{
                fontWeight: "600",
                color: "#000000",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // color: (theme) => theme.palette.secondary.main,
              }}
            >
              {modalData?.discount?.toFixed(2)}
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ p: "0px 10px ", mt: 2 }}>
            <Typography
              sx={{
                fontWeight: "600",
                color: "#01008B",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // color: (theme) => theme.palette.primary.main,
              }}
            >
              Payable Amount:
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ p: "0px 10px ", textAlign: "right", mt: 2 }}>
            <Typography
              sx={{
                fontWeight: "600",
                color: "#000000",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // color: (theme) => theme.palette.secondary.main,
              }}
            >
              ₹ {modalData?.balanceAmount?.toFixed(2)}
            </Typography>
          </Grid>
          {/* <Grid item xs={12}>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
              }}
              onChange={(e) => {}}
            >
              <FormControlLabel
                disabled
                sx={{
                  color: (theme) => theme.palette.primary.main,
                }}
                value="Cash"
                control={
                  <Radio
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                    }}
                  />
                }
                label="CashPayment"
              />
              <FormControlLabel
                value="Credit"
                sx={{
                  color: (theme) => theme.palette.primary.main,
                }}
                selected={true}
                checked={true}
                control={
                  <Radio
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                    }}
                  />
                }
                label="Credit Sale"
              />
              <FormControlLabel
                value="Digital"
                sx={{
                  color: (theme) => theme.palette.primary.main,
                }}
                disabled
                control={
                  <Radio
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                    }}
                  />
                }
                label="Online Payment"
              />
            </RadioGroup>
          </Grid> */}
        </Grid>
        {/* 
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              setOpen(false);
            }}
          >
            Save
          </Button>
        </DialogActions> */}
      </Box>
    </Modal>
  );
}
